import React, { useContext, useEffect, useState } from "react";
import { Modal, TextInput, Label } from "flowbite-react";
import Button_submit from "../components/Button_submit";
import axios from "axios";
import GlobalContext from "../connections/GlobalContext";
import Swal from "sweetalert2";
import Head_data from "../components/Head_data";
import DataTable from "react-data-table-component";
import Modal_sub from "react-modal";
import { FaEye } from "react-icons/fa";

const Services = ({ isSidebarOpen, theme }) => {
    const { globalValue } = useContext(GlobalContext);

    const [open, setOpen] = useState(false);
    const [serviceName, setServiceName] = useState("");
    const [error, setError] = useState("");
    const [mode, setMode] = useState("add");
    const [flag_branch, setFlag_branch] = useState(sessionStorage.getItem("branch"));
    const [flag_berror, setFlag_berror] = useState("");
    const [labour_charge, setLabour_charge] = useState("");
    const [services, setServices] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filtered, setFiltered] = useState(services);
    const [branches, setBranches] = useState([]);
    const [id, setId] = useState();

    const [openSubModal, setOpenSubModal] = useState(false);
    const [selectedServiceId, setSelectedServiceId] = useState(null);
    const [subCategories, setSubCategories] = useState([]);
    const [subName, setSubName] = useState("");
    const [subAmount, setSubAmount] = useState("");
    const [subMode, setSubMode] = useState("add");
    const [subId, setSubId] = useState(null);
    const [subError, setSubError] = useState("");

    useEffect(() => {
        const filteredData = services.filter((branch) =>
            branch[2]?.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFiltered(filteredData);
    }, [searchTerm, services]);

    const handleInputChange = (e) => {
        setServiceName(e.target.value);
        if (error) setError("");
    };

    const fetchData = async () => {
        try {
            const response = await axios.get(`${globalValue}/services`, {
                params: {
                    data: sessionStorage.getItem("branch"),
                    position: "",
                },
                headers: {
                    "x-access-token": sessionStorage.getItem("token"),
                },
            });
            setServices(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const fetchData1 = () => {
        fetch(globalValue + "/branches", {
            method: "GET",
            headers: {
                "x-access-token": sessionStorage.getItem("token"),
            },
        })
            .then((res) => res.json())
            .then((dat) => {
                setBranches(dat);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    };

    useEffect(() => {
        fetchData();
        fetchData1();
    }, []);

    const handleSubmit = async () => {
        if (serviceName.trim() === "" || flag_branch === "" || labour_charge === "") {
            setError("All fields are required.");
            return;
        }
        try {
            const response = await axios.post(`${globalValue}/service_add`, { serviceName, flag_branch, labour_charge }, {
                headers: { "x-access-token": sessionStorage.getItem("token") },
            });
            if (response.data.message === "Service added successfully") {
                Swal.fire({ icon: "success", title: "Success!", text: `Service added successfully with ID: ${response.data.service_id}` });
                setOpen(false);
                setServiceName("");
                fetchData();
            }
        } catch (error) {
            Swal.fire({ icon: "error", title: "Error!", text: error.response?.data?.error || "Something went wrong!" });
        }
    };

    const handleEdit = async () => {
        if (serviceName.trim() === "" || flag_branch === "") {
            setError("Service Name is required.");
            return;
        }
        try {
            const response = await axios.post(`${globalValue}/service_edit`, {
                serviceName, flag_branch, labour_charge, id
            }, {
                headers: { "x-access-token": sessionStorage.getItem("token") },
            });
            if (response.data === "success") {
                Swal.fire({ icon: "success", title: "Success!", text: `Service Edited successfully` });
                setOpen(false);
                setServiceName("");
                fetchData();
            }
        } catch (error) {
            Swal.fire({ icon: "error", title: "Error!", text: error.response?.data?.error || "Something went wrong!" });
        }
    };

    const handleDelete = async (id) => {
        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "This action cannot be undone!",
                icon: "warning",
                showCancelButton: true
            });
            if (result.isConfirmed) {
                const response = await axios.post(`${globalValue}/service_delete`, { id }, {
                    headers: { "x-access-token": sessionStorage.getItem("token") },
                });
                if (response.data === "success") {
                    Swal.fire({ icon: "success", title: "Deleted!", text: `Service deleted successfully` });
                    setServiceName("");
                    fetchData();
                }
            }
        } catch (error) {
            Swal.fire({ icon: "error", title: "Error!", text: error.response?.data?.error || "Something went wrong!" });
        }
    };

    const fetchSubCategories = async (serviceId) => {
        try {
            const res = await axios.get(`${globalValue}/subcategories`, {
                params: { service_id: serviceId },
                headers: { "x-access-token": sessionStorage.getItem("token") }
            });
            setSubCategories(res.data.subcategories);
        } catch (e) {
            Swal.fire({ icon: "error", title: "Error!", text: "Could not fetch subcategories." });
        }
    };

    const handleSubAdd = async () => {
        if (!subName.trim() || !subAmount.trim()) {
            setSubError("All fields required");
            return;
        }
        try {
            const res = await axios.post(`${globalValue}/subcategory_add`, {
                name: subName, amount: subAmount, service_id: selectedServiceId
            }, {
                headers: { "x-access-token": sessionStorage.getItem("token") }
            });
            if (res.data.message === "SubCategory added successfully") {
                Swal.fire({ icon: "success", title: "Success!", text: "Subcategory added" });
                setSubName("");
                setSubAmount("");
                fetchSubCategories(selectedServiceId);
                setSubMode("add");
            }
        } catch (error) {
            Swal.fire({ icon: "error", title: "Error!", text: error.response?.data?.error || "Error!" });
        }
    };

    const handleSubEdit = async () => {
        if (!subName.trim() || !subAmount.trim()) {
            setSubError("All fields required");
            return;
        }
        try {
            const res = await axios.post(`${globalValue}/subcategory_edit`, {
                name: subName, amount: subAmount, id: subId, service_id: selectedServiceId
            }, {
                headers: { "x-access-token": sessionStorage.getItem("token") }
            });
            if (res.data.message === "SubCategory updated successfully") {
                Swal.fire({ icon: "success", title: "Success!", text: "Subcategory edited" });
                setSubName("");
                setSubAmount("");
                fetchSubCategories(selectedServiceId);
                setSubMode("add");
            }
        } catch (error) {
            Swal.fire({ icon: "error", title: "Error!", text: error.response?.data?.error || "Error!" });
        }
    };

    const handleSubDelete = async (id) => {
        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "Delete this subcategory?",
                icon: "warning",
                showCancelButton: true
            });
            if (result.isConfirmed) {
                const res = await axios.post(`${globalValue}/subcategory_delete`, { id , service_id: selectedServiceId}, {
                    headers: { "x-access-token": sessionStorage.getItem("token") }
                });
                if (res.data.message === "SubCategory deleted successfully") {
                    Swal.fire({ icon: "success", title: "Deleted!", text: "Subcategory deleted" });
                    fetchSubCategories(selectedServiceId);
                }
            }
        } catch (error) {
            Swal.fire({ icon: "error", title: "Error!", text: error.response?.data?.error || "Error!" });
        }
    };

    const columns = [
        { name: 'Service Id', selector: row => row[1] },
        { name: 'Service Name', selector: row => row[2] },
        { name: 'Default Labour Charge', selector: row => row[5] },
        {
            name: 'Action', center: true,
            cell: row => (
                <div className="flex gap-2">
                    <button
                        onClick={() => {
                            setSelectedServiceId(row[1]);
                            fetchSubCategories(row[1]);
                            setOpenSubModal(true);
                            console.log(openSubModal + "  clickked");
                        }}
                        className="p-2 text-blue-700 border bg-gray-100 hover:bg-blue-200 rounded-md shadow-xl">
                        <FaEye />
                    </button>
                    <button
                        onClick={(e) => {
                            setMode("edit");
                            setServiceName(row[2]);
                            setFlag_branch(row[4]);
                            setLabour_charge(row[5]);
                            setId(row[1]);
                            setOpen(true);
                        }}
                        className="p-2 text-white border bg-blue-700 hover:bg-blue-800 rounded-md shadow-xl">
                        <i className="fa fa-edit"></i>
                    </button>
                    <button
                        onClick={() => handleDelete(row[1])}
                        className="p-2 text-white border bg-yellow-500 hover:bg-yellow-800 rounded-md shadow-xl">
                        <i className="fa fa-trash"></i>
                    </button>
                </div>
            ),
        },
    ];

    const customStyles = {
        table: { style: { backgroundColor: 'white', border: "solid 1px rgb(226, 232, 240)" } },
        headCells: { style: { backgroundColor: 'rgb(226, 232, 240)', fontWeight: 'bold' } },
    };

    return (
        <div>
            <div
                className={`md:ml-[250px] w-full md:w-[calc(100%-250px)] mt-16 h-[92vh] flex justify-center items-center box-border ${theme === "dark" ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-800"
                    }`}
            >
                <div
                    className={`w-[95%] md:w-[98%] h-[95%] px-4 py-2 rounded-xl shadow-xl overflow-auto ${theme === "dark" ? "bg-gray-800 text-gray-200" : "bg-white text-gray-800"
                        }`}
                >
                    <div className="w-full flex justify-between items-center text-gray-600">
                        <Head_data data="Manage Services" font="" size="3xl" />
                        <button onClick={() => { setMode("add"); setOpen(true); setServiceName(""); setFlag_branch(sessionStorage.getItem("branch")) }}
                            className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700">
                            Add Service
                        </button>
                    </div>
                    <input type="text" placeholder="Search by service name"
                        value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
                        className="w-full md:w-1/3 px-4 my-2 py-2 border rounded-xl shadow-sm"
                    />
                    <div className="py-6">
                        <DataTable columns={columns} data={filtered} customStyles={customStyles} pagination />
                    </div>
                </div>
            </div>

            <Modal show={open} onClose={() => setOpen(false)}>
                <Modal.Header>{mode === "add" ? "Add Service" : "Edit Service"}</Modal.Header>
                <Modal.Body>
                    <form className="space-y-6">
                        <div>
                            <Label value="Service Name" />
                            <TextInput value={serviceName} onChange={handleInputChange} required />
                            {error && <p className="text-sm text-red-600">{error}</p>}
                        </div>
                        <div>
                            <Label value="Default Labour Charge" />
                            <TextInput type="number" value={labour_charge} onChange={(e) => setLabour_charge(e.target.value)} required />
                        </div>
                        <div>
                            <select value={flag_branch} onChange={(e) => setFlag_branch(e.target.value)}
                                disabled={sessionStorage.getItem("position") !== "superadmin"}>
                                <option value="" disabled>Select Branch</option>
                                {branches.map((data, index) => (
                                    <option key={index} value={data[1]}>{data[2]}</option>
                                ))}
                            </select>
                            {flag_berror && <p className="text-sm text-red-600">{flag_berror}</p>}
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button_submit onClick={() => mode === "add" ? handleSubmit() : handleEdit()} data={mode === "add" ? "Submit" : "Edit"} />
                </Modal.Footer>
            </Modal>

            <Modal show={openSubModal} onClose={() => setOpenSubModal(false)}>
                <Modal.Header>Handle Sub Category</Modal.Header>
                <Modal.Body>
                    
                        {/* <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b pb-2">
                            Sub-Categories
                        </h2> */}

                        <div className="space-y-3">
                            <input
                                type="text"
                                placeholder="Sub-Category Name"
                                value={subName}
                                onChange={(e) => setSubName(e.target.value)}
                                className="border border-gray-300 rounded-lg px-3 py-2 w-full focus:ring-2 focus:ring-blue-400 focus:outline-none"
                            />
                            <input
                                type="number"
                                placeholder="Amount"
                                value={subAmount}
                                onChange={(e) => setSubAmount(e.target.value)}
                                className="border border-gray-300 rounded-lg px-3 py-2 w-full focus:ring-2 focus:ring-blue-400 focus:outline-none"
                            />
                            {subError && (
                                <p className="text-sm text-red-500 font-medium">{subError}</p>
                            )}
                        </div>

                        <div className="flex gap-2 justify-end mt-4">
                            <button
                                className="bg-green-500 hover:bg-green-600 transition text-white px-4 py-2 rounded-lg shadow"
                                onClick={() =>
                                    subMode === "add" ? handleSubAdd() : handleSubEdit()
                                }
                            >
                                {subMode === "add" ? "Add" : "Update"}
                            </button>
                            <button
                                className="bg-gray-400 hover:bg-gray-500 transition text-white px-4 py-2 rounded-lg shadow"
                                onClick={() => {
                                    setSubMode("add");
                                    setSubName("");
                                    setSubAmount("");
                                    setSubId(null);
                                }}
                            >
                                Cancel
                            </button>
                        </div>

                        <div className="mt-6 overflow-x-auto">
                            <table className="w-full border border-gray-200 rounded-lg overflow-hidden shadow-sm">
                                <thead className="bg-gray-100 text-gray-700">
                                    <tr>
                                        <th className="border px-3 py-2 text-left">ID</th>
                                        <th className="border px-3 py-2 text-left">Name</th>
                                        <th className="border px-3 py-2 text-left">Amount</th>
                                        <th className="border px-3 py-2 text-left">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {subCategories &&
                                        Array.isArray(subCategories) &&
                                        subCategories.map((sub) => (
                                            <tr
                                                key={sub.id}
                                                className="hover:bg-gray-50 transition"
                                            >
                                                <td className="border px-3 py-2">{sub.id}</td>
                                                <td className="border px-3 py-2">{sub.name}</td>
                                                <td className="border px-3 py-2">{sub.amount}</td>
                                                <td className="border px-3 py-2 flex gap-2">
                                                    <button
                                                        className="bg-blue-500 hover:bg-blue-600 transition text-white px-3 py-1 rounded shadow"
                                                        onClick={() => {
                                                            setSubMode("edit");
                                                            setSubName(sub.name);
                                                            setSubAmount(sub.amount);
                                                            setSubId(sub.id);
                                                        }}
                                                    >
                                                        Edit
                                                    </button>
                                                    <button
                                                        className="bg-red-500 hover:bg-red-600 transition text-white px-3 py-1 rounded shadow"
                                                        onClick={() => handleSubDelete(sub.id)}
                                                    >
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    {subCategories.length === 0 && (
                                        <tr>
                                            <td
                                                colSpan="4"
                                                className="text-center py-4 text-gray-500"
                                            >
                                                No sub-categories found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                 
                </Modal.Body>
            </Modal>

        </div>
    );
};

export default Services;
